import React, { useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Select from 'react-select';
import './AdminUserSettings.scss';

import { updateUserSettings } from '../../../../Actions/UserActions';
import { getSettings, getName } from '../../../../Helpers/user_helpers';
import SelectOption from '../../../General/SelectOption';

const MATCHING_PRIORITY_OPTIONS = [
  { value: 'normal', label: 'Normal Priority', sublabel: 'Pins added by this user go through the default matching queue' },
  { value: 'high', label: 'High Priority', sublabel: 'Pins added by this user will be prioritized for product matching and display in Latest Finds' },
  { value: 'low', label: 'Low Priority', sublabel: 'Pins added by this user will be prioritized after the normal and high priority queues' }
];

const AdminUserSettings = props => {
  const { user } = props;
  const { isLowPriorityForMatching, isHighPriorityForMatching } = getSettings(user);

  const currentPriority = isHighPriorityForMatching ? 'high' : isLowPriorityForMatching ? 'low' : 'normal';
  const [isUpdating, setIsUpdating] = useState(false);
  const updateMatchingPriority = async newPriority => {
    if (isUpdating) return window.ALERT.warn('Still saving...');
    setIsUpdating(true);
    await props.updateUserSettings({
      isHighPriorityForMatching: newPriority === 'high',
      isLowPriorityForMatching: newPriority === 'low'
    });
    window.ALERT.success(`${getName(user)} is now ${newPriority} priority for product matching`);
    setIsUpdating(false);
  };

  return (
    <div className='admin-user-settings-container settings-section'>
      <div className='settings-section-title'>Product Matching Priority</div>
      <div className='switch-container'>
        <Select
          options={MATCHING_PRIORITY_OPTIONS}
          value={MATCHING_PRIORITY_OPTIONS.find(o => o.value === currentPriority)}
          onChange={selected => {
            updateMatchingPriority(selected.value);
          }}
          components={{ Option: SelectOption }}
          styles={{
            singleValue: provided => ({
              ...provided,
              fontWeight: 'bold',
              fontSize: '14px'
            })
          }}
        />
      </div>
    </div>
  );
};

AdminUserSettings.propTypes = {
  user: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {
  updateUserSettings
})(AdminUserSettings);
